import React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Button } from "@/components/ui/button";
import { ArrowRight, Loader2 } from "lucide-react";
const wp_query = new WP_Query({
  per_page: 6,
  orderby: 'date',
  order: 'desc',
  status: 'publish'
});
function GalleryGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="1625" className="flex justify-center items-center min-h-[400px] w-full">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-destructive">
        <p>Görseller yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Henüz sergilenecek bir değişim bulunmuyor.</p>
      </div>;
  }
  return <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8 px-4 md:px-0">
      {products.map((product, i) => <div key={product.id} data-index={i} className="break-inside-avoid group relative rounded-sm bg-card transition-all duration-500 hover:-translate-y-2 hover:shadow-xl shadow-md overflow-hidden">
          {}
          <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-secondary text-muted-foreground">
                <span className="text-sm font-sans">Görsel Mevcut Değil</span>
              </div>}
            
            {}
            <div className="absolute inset-x-0 bottom-0 translate-y-full transform bg-primary/95 backdrop-blur-sm border-t border-primary/20 p-6 transition-transform duration-500 ease-out group-hover:translate-y-0">
              <div className="flex flex-col gap-3">
                <Link to={product.link} className="block">
                  <h3 className="font-serif text-2xl font-bold text-primary-foreground drop-shadow-sm">
                    {product.title}
                  </h3>
                </Link>
                
                {product.short_description && <div className="text-sm text-primary-foreground/90 line-clamp-2 font-sans tracking-wide [&_p]:mb-0" dangerouslySetInnerHTML={{
              __html: product.short_description
            }} />}
                
                <div className="flex items-center justify-between pt-2">
                  <span className="text-lg font-serif font-semibold text-primary-foreground">
                    {product.price ? `${product.price} TL` : 'Ücretsiz Muayene'}
                  </span>
                  <div className="w-auto">
                    <AddToCartButton productId={product.id} variant="secondary" size="sm" buttonClassName="bg-primary-foreground text-primary hover:bg-secondary hover:text-primary-foreground font-medium shadow-sm rounded-sm transition-colors duration-300" text="Detaylı Bilgi" showQuantity={false} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}
export default function CustomCakesGallery() {
  return;
}